export interface Country {
  title: string;
  titleEn: string;
  value: string;
}

export const COUNTRIES: Country[] = [
  { title: 'افغانستان', titleEn: 'Afghanistan', value: 'AF' },
  { title: 'Åland', titleEn: 'Åland Islands', value: 'AX' },
  { title: 'Shqipëria', titleEn: 'Albania', value: 'AL' },
  { title: 'الجزائر', titleEn: 'Algeria', value: 'DZ' },
  { title: 'American Samoa', titleEn: 'American Samoa', value: 'AS' },
  { title: 'Andorra', titleEn: 'Andorra', value: 'AD' },
  { title: 'Angola', titleEn: 'Angola', value: 'AO' },
  { title: 'Anguilla', titleEn: 'Anguilla', value: 'AI' },
  { title: 'Antigua and Barbuda', titleEn: 'Antigua and Barbuda', value: 'AG' },
  { title: 'Argentina', titleEn: 'Argentina', value: 'AR' },
  { title: 'Hayastán', titleEn: 'Armenia', value: 'AM' },
  { title: 'Orílẹ́ède Àríwá Amẹ́ríkà', titleEn: 'Aruba', value: 'AW' },
  { title: 'Australia', titleEn: 'Australia', value: 'AU' },
  { title: 'Österreich', titleEn: 'Austria', value: 'AT' },
  { title: 'Azərbaycan', titleEn: 'Azerbaijan', value: 'AZ' },
  { title: 'Bahamas', titleEn: 'Bahamas', value: 'BS' },
  { title: 'البحرين', titleEn: 'Bahrain', value: 'BH' },
  { title: 'Bangladesh', titleEn: 'Bangladesh', value: 'BD' },
  { title: 'Barbados', titleEn: 'Barbados', value: 'BB' },
  { title: 'Беларусь', titleEn: 'Belarus', value: 'BY' },
  { title: 'België', titleEn: 'Belgium', value: 'BE' },
  { title: 'Belize', titleEn: 'Belize', value: 'BZ' },
  { title: 'Bénin', titleEn: 'Benin', value: 'BJ' },
  { title: 'Druk Yul', titleEn: 'Bhutan', value: 'BT' },
  { title: 'Wuliwya', titleEn: 'Bolivia', value: 'BO' },
  { title: 'Bosna i Hercegovina', titleEn: 'Bosnia and Herzegovina', value: 'BA' },
  { title: 'Botswana', titleEn: 'Botswana', value: 'BW' },
  { title: 'Brasil', titleEn: 'Brazil', value: 'BR' },
  { title: 'بروناي', titleEn: 'Brunei Darussalam', value: 'BN' },
  { title: 'България', titleEn: 'Bulgaria', value: 'BG' },
  { title: 'Burkina Faso', titleEn: 'Burkina Faso', value: 'BF' },
  { title: 'Uburundi', titleEn: 'Burundi', value: 'BI' },
  { title: 'កម្ពុជា', titleEn: 'Cambodia', value: 'KH' },
  { title: 'Cameroon', titleEn: 'Cameroon', value: 'CM' },
  { title: 'Canada', titleEn: 'Canada', value: 'CA' },
  { title: 'Cabo Verde', titleEn: 'Cape Verde', value: 'CV' },
  { title: 'Ködörösêse tî Bêafrîka', titleEn: 'Central African Republic', value: 'CF' },
  { title: 'تشاد', titleEn: 'Chad', value: 'TD' },
  { title: 'Chile', titleEn: 'Chile', value: 'CL' },
  { title: '中国', titleEn: 'China', value: 'CN' },
  { title: 'Colombia', titleEn: 'Colombia', value: 'CO' },
  { title: 'Komori', titleEn: 'Comoros', value: 'KM' },
  { title: 'République du Congo', titleEn: 'Congo', value: 'CG' },
  { title: 'République démocratique du Congo', titleEn: 'Congo, Democratic Republic of the', value: 'CD' },
  { title: 'Costa Rica', titleEn: 'Costa Rica', value: 'CR' },
  { title: "Côte d'Ivoire", titleEn: "Côte d'Ivoire", value: 'CI' },
  { title: 'Hrvatska', titleEn: 'Croatia', value: 'HR' },
  { title: 'Cuba', titleEn: 'Cuba', value: 'CU' },
  { title: 'Κύπρος', titleEn: 'Cyprus', value: 'CY' },
  { title: 'Česko', titleEn: 'Czechia', value: 'CZ' },
  { title: 'Danmark', titleEn: 'Denmark', value: 'DK' },
  { title: 'Djibouti', titleEn: 'Djibouti', value: 'DJ' },
  { title: 'Dominican Republic', titleEn: 'Dominican Republic', value: 'DO' },
  { title: 'Timor-Leste', titleEn: 'East Timor', value: 'TL' },
  { title: 'Ecuador', titleEn: 'Ecuador', value: 'EC' },
  { title: 'مصر', titleEn: 'Egypt', value: 'EG' },
  { title: 'El Salvador', titleEn: 'El Salvador', value: 'SV' },
  { title: 'Guinea Ecuatorial', titleEn: 'Equatorial Guinea', value: 'GQ' },
  { title: 'Ertra', titleEn: 'Eritrea', value: 'ER' },
  { title: 'Eesti', titleEn: 'Estonia', value: 'EE' },
  { title: 'Eswatini', titleEn: 'Eswatini', value: 'SZ' },
  { title: 'ኢትዮጵያ', titleEn: 'Ethiopia', value: 'ET' },
  { title: 'Fiji', titleEn: 'Fiji', value: 'FJ' },
  { title: 'Suomi', titleEn: 'Finland', value: 'FI' },
  { title: 'France', titleEn: 'France', value: 'FR' },
  { title: 'République gabonaise', titleEn: 'Gabon', value: 'GA' },
  { title: 'The Gambia', titleEn: 'Gambia', value: 'GM' },
  { title: 'საქართველო', titleEn: 'Georgia', value: 'GE' },
  { title: 'Deutschland', titleEn: 'Germany', value: 'DE' },
  { title: 'Ghana', titleEn: 'Ghana', value: 'GH' },
  { title: 'Ελλάς', titleEn: 'Greece', value: 'GR' },
  { title: 'Grenada', titleEn: 'Grenada', value: 'GD' },
  { title: 'Guatemala', titleEn: 'Guatemala', value: 'GT' },
  { title: 'Guinée', titleEn: 'Guinea', value: 'GN' },
  { title: 'Guiné-Bissau', titleEn: 'Guinea-Bissau', value: 'GW' },
  { title: 'Guyana', titleEn: 'Guyana', value: 'GY' },
  { title: 'Ayiti', titleEn: 'Haiti', value: 'HT' },
  { title: 'Honduras', titleEn: 'Honduras', value: 'HN' },
  { title: '香港', titleEn: 'Hong Kong', value: 'HK' },
  { title: 'Magyarország', titleEn: 'Hungary', value: 'HU' },
  { title: 'Ísland', titleEn: 'Iceland', value: 'IS' },
  { title: 'Bhārat', titleEn: 'India', value: 'IN' },
  { title: 'Indonesia', titleEn: 'Indonesia', value: 'ID' },
  { title: 'Īrān', titleEn: 'Iran', value: 'IR' },
  { title: 'العراق', titleEn: 'Iraq', value: 'IQ' },
  { title: 'Éire', titleEn: 'Ireland', value: 'IE' },
  { title: 'إسرائيل', titleEn: 'Israel', value: 'IL' },
  { title: 'Italia', titleEn: 'Italy', value: 'IT' },
  { title: 'Jamaica', titleEn: 'Jamaica', value: 'JM' },
  { title: '日本', titleEn: 'Japan', value: 'JP' },
  { title: 'الأردن', titleEn: 'Jordan', value: 'JO' },
  { title: 'Қазақстан', titleEn: 'Kazakhstan', value: 'KZ' },
  { title: 'Kenya', titleEn: 'Kenya', value: 'KE' },
  { title: 'Tungaru', titleEn: 'Kiribati', value: 'KI' },
  { title: 'Kosova', titleEn: 'Kosovo', value: 'XK' },
  { title: 'دولة الكويت', titleEn: 'Kuwait', value: 'KW' },
  { title: 'Кыргызстан', titleEn: 'Kyrgyzstan', value: 'KG' },
  { title: 'ປະເທດລາວ', titleEn: 'Laos', value: 'LA' },
  { title: 'Latvija', titleEn: 'Latvia', value: 'LV' },
  { title: 'Liban', titleEn: 'Lebanon', value: 'LB' },
  { title: 'Lesotho', titleEn: 'Lesotho', value: 'LS' },
  { title: 'Liberia', titleEn: 'Liberia', value: 'LR' },
  { title: 'ليبيا', titleEn: 'Libya', value: 'LY' },
  { title: 'Liechtenstein', titleEn: 'Liechtenstein', value: 'LI' },
  { title: 'Lietuva', titleEn: 'Lithuania', value: 'LT' },
  { title: 'Lëtzebuerg', titleEn: 'Luxembourg', value: 'LU' },
  { title: 'Madagasikara', titleEn: 'Madagascar', value: 'MG' },
  { title: 'Malaŵi', titleEn: 'Malawi', value: 'MW' },
  { title: '马来西亚', titleEn: 'Malaysia', value: 'MY' },
  { title: 'Dhivehi Raajje', titleEn: 'Maldives', value: 'MV' },
  { title: 'Mali', titleEn: 'Mali', value: 'ML' },
  { title: 'Malta', titleEn: 'Malta', value: 'MT' },
  { title: 'Aorōkin M̧ajeļ', titleEn: 'Marshall Islands', value: 'MH' },
  { title: 'موريتانيا', titleEn: 'Mauritania', value: 'MR' },
  { title: 'Moris', titleEn: 'Mauritius', value: 'MU' },
  { title: 'México', titleEn: 'Mexico', value: 'MX' },
  { title: 'Micronesia', titleEn: 'Micronesia, Federated States of', value: 'FM' },
  { title: 'Moldova', titleEn: 'Moldova', value: 'MD' },
  { title: 'Monaco', titleEn: 'Monaco', value: 'MC' },
  { title: 'Монгол Улс', titleEn: 'Mongolia', value: 'MN' },
  { title: 'Crna Gora', titleEn: 'Montenegro', value: 'ME' },
  { title: 'المغرب', titleEn: 'Morocco', value: 'MA' },
  { title: 'Moçambique', titleEn: 'Mozambique', value: 'MZ' },
  { title: 'မြန်မာ', titleEn: 'Myanmar', value: 'MM' },
  { title: 'Namibia', titleEn: 'Namibia', value: 'NA' },
  { title: 'Naoero', titleEn: 'Nauru', value: 'NR' },
  { title: 'नेपाल', titleEn: 'Nepal', value: 'NP' },
  { title: 'Nederland', titleEn: 'Netherlands', value: 'NL' },
  { title: 'Aotearoa', titleEn: 'New Zealand', value: 'NZ' },
  { title: 'Nicaragua', titleEn: 'Nicaragua', value: 'NI' },
  { title: 'Niger', titleEn: 'Niger', value: 'NE' },
  { title: 'Nigeria', titleEn: 'Nigeria', value: 'NG' },
  { title: 'Северна Македонија', titleEn: 'North Macedonia', value: 'MK' },
  { title: 'Norge', titleEn: 'Norway', value: 'NO' },
  { title: 'عُمان', titleEn: 'Oman', value: 'OM' },
  { title: 'پاکستان', titleEn: 'Pakistan', value: 'PK' },
  { title: 'Belau', titleEn: 'Palau', value: 'PW' },
  { title: 'فلسطين', titleEn: 'Palestine, State of', value: 'PS' },
  { title: 'Panamá', titleEn: 'Panama', value: 'PA' },
  { title: 'Papua Niugini', titleEn: 'Papua New Guinea', value: 'PG' },
  { title: 'Paraguái', titleEn: 'Paraguay', value: 'PY' },
  { title: 'Perú', titleEn: 'Peru', value: 'PE' },
  { title: 'Pilipinas', titleEn: 'Philippines', value: 'PH' },
  { title: 'Polska', titleEn: 'Poland', value: 'PL' },
  { title: 'Portugal', titleEn: 'Portugal', value: 'PT' },
  { title: 'قطر', titleEn: 'Qatar', value: 'QA' },
  { title: 'România', titleEn: 'Romania', value: 'RO' },
  { title: 'Россия', titleEn: 'Russia', value: 'RU' },
  { title: 'Rwanda', titleEn: 'Rwanda', value: 'RW' },
  { title: 'Saint Kitts and Nevis', titleEn: 'Saint Kitts and Nevis', value: 'KN' },
  { title: 'Saint Lucia', titleEn: 'Saint Lucia', value: 'LC' },
  { title: 'Saint Vincent and the Grenadines', titleEn: 'Saint Vincent and the Grenadines', value: 'VC' },
  { title: 'Sāmoa', titleEn: 'Samoa', value: 'WS' },
  { title: 'San Marino', titleEn: 'San Marino', value: 'SM' },
  { title: 'São Tomé e Príncipe', titleEn: 'São Tomé and Príncipe', value: 'ST' },
  { title: 'المملكة العربية السعودية', titleEn: 'Saudi Arabia', value: 'SA' },
  { title: 'Sénégal', titleEn: 'Senegal', value: 'SN' },
  { title: 'Srbija', titleEn: 'Serbia', value: 'RS' },
  { title: 'Sesel', titleEn: 'Seychelles', value: 'SC' },
  { title: 'Sierra Leone', titleEn: 'Sierra Leone', value: 'SL' },
  { title: 'Singapura', titleEn: 'Singapore', value: 'SG' },
  { title: 'Slovensko', titleEn: 'Slovakia', value: 'SK' },
  { title: 'Slovenija', titleEn: 'Slovenia', value: 'SI' },
  { title: 'Solomon Islands', titleEn: 'Solomon Islands', value: 'SB' },
  { title: 'Soomaaliya', titleEn: 'Somalia', value: 'SO' },
  { title: 'Suid-Afrika', titleEn: 'South Africa', value: 'ZA' },
  { title: 'South Georgia and the South Sandwich Islands', titleEn: 'South Georgia and the South Sandwich Islands', value: 'GS' },
  { title: 'South Sudan', titleEn: 'South Sudan', value: 'SS' },
  { title: 'España', titleEn: 'Spain', value: 'ES' },
  { title: 'ශ්‍රී ලංකාව', titleEn: 'Sri Lanka', value: 'LK' },
  { title: 'السودان', titleEn: 'Sudan', value: 'SD' },
  { title: 'Surinam', titleEn: 'Suriname', value: 'SR' },
  { title: 'Sverige', titleEn: 'Sweden', value: 'SE' },
  { title: 'Schweiz', titleEn: 'Switzerland', value: 'CH' },
  { title: 'سوريا', titleEn: 'Syrian Arab Republic', value: 'SY' },
  { title: 'Тоҷикистон', titleEn: 'Tajikistan', value: 'TJ' },
  { title: 'Tanzania', titleEn: 'Tanzania, United Republic of', value: 'TZ' },
  { title: 'ประเทศไทย', titleEn: 'Thailand', value: 'TH' },
  { title: 'Togo', titleEn: 'Togo', value: 'TG' },
  { title: 'Tonga', titleEn: 'Tonga', value: 'TO' },
  { title: 'Trinidad and Tobago', titleEn: 'Trinidad and Tobago', value: 'TT' },
  { title: 'Tunes', titleEn: 'Tunisia', value: 'TN' },
  { title: 'Türkiye', titleEn: 'Turkey', value: 'TR' },
  { title: 'Tuvalu', titleEn: 'Tuvalu', value: 'TV' },
  { title: 'Uganda', titleEn: 'Uganda', value: 'UG' },
  { title: 'Україна', titleEn: 'Ukraine', value: 'UA' },
  { title: 'الإمارات العربيّة المتّحدة', titleEn: 'United Arab Emirates', value: 'AE' },
  { title: 'United Kingdom', titleEn: 'United Kingdom', value: 'GB' },
  { title: 'United States', titleEn: 'United States', value: 'US' },
  { title: 'Uruguay', titleEn: 'Uruguay', value: 'UY' },
  { title: 'O‘zbekiston', titleEn: 'Uzbekistan', value: 'UZ' },
  { title: 'Vanuatu', titleEn: 'Vanuatu', value: 'VU' },
  { title: 'Città del Vaticano', titleEn: 'Vatican City', value: 'VA' },
  { title: 'Venezuela', titleEn: 'Venezuela', value: 'VE' },
  { title: 'Việt Nam', titleEn: 'Viet Nam', value: 'VN' },
  { title: 'اليَمَن', titleEn: 'Yemen', value: 'YE' },
  { title: 'Zambia', titleEn: 'Zambia', value: 'ZM' },
  { title: 'Zimbabwe', titleEn: 'Zimbabwe', value: 'ZW' }
];
